import { ModuleBase, Text, HeadingTag, Stack, ResponsiveImage } from '@/components';
import { isColorDark } from '@/utils';
import classNames from 'classnames';

const CenteredTextSectionModule = ({ data }) => {
  const { headingTitle, headingStyle, description, bodySize, icon, iconPosition } = data || {};
  const dark = isColorDark(data?.backgroundColour);
  const isGothamHeading = headingStyle?.toLowerCase() === 'gotham';
  const isLargeBody = bodySize?.toLowerCase() === 'large';
  const position = iconPosition?.toLowerCase() || 'top';
  const iconInMiddle = icon && position === 'middle';

  const iconEl = icon && (
    <div className="mx-auto mb-6 h-20 w-20 lg:h-[120px] lg:w-[120px]">
      <ResponsiveImage animate image={icon} widths={{ xs: 80, md: 120, lg: 120 }} heights={{ xs: null }} />
    </div>
  );

  return (
    <ModuleBase data={data}>
      <Stack className="container px-6 md:px-10">
        <div className="mx-auto w-full max-w-[890px] text-center">
          {position === 'top' && iconEl}

          {headingTitle?.heading && (
            <HeadingTag
              animate
              data={headingTitle}
              className={classNames(
                'color-from-bg',
                iconInMiddle ? 'mb-6' : 'mb-10', // 24px above a middle icon, else standard 40px
                isGothamHeading
                  ? 'font-gotham text-desktop-medium font-s-light leading-[38px]'
                  : 'font-larken text-[36px] font-normal leading-tight sm:text-[44px] lg:text-[52px] xl:text-[64px] xl:leading-[68px]',
              )}
            />
          )}

          {position === 'middle' && iconEl}

          {description && (
            <Text
              dangerouslySetInnerHTML={{ __html: description }}
              className={classNames(
                'richtext-content font-gotham font-s-light',
                '[&_p:last-child]:mb-0 [&_p]:mb-4',
                '[&_ol]:inline-block [&_ol]:text-left [&_ul]:inline-block [&_ul]:text-left',
                dark ? 'text-white/75' : 'text-black/75',
                isLargeBody ? 'text-paragraph leading-7' : 'text-small-paragraph leading-6',
              )}
            />
          )}

          {position === 'bottom' && (
            <div className="mx-auto mt-6 h-20 w-20 lg:h-[120px] lg:w-[120px]">
              <ResponsiveImage animate image={icon} widths={{ xs: 80, md: 120, lg: 120 }} heights={{ xs: null }} />
            </div>
          )}
        </div>
      </Stack>
    </ModuleBase>
  );
};

export default CenteredTextSectionModule;
